import { io } from 'socket.io-client';
const URL = 'https://dpp.baavlibuch.com';
export const socketClient = io(URL);